import { render, staticRenderFns } from "./create.vue?vue&type=template&id=1eedcad2"
import script from "./create.vue?vue&type=script&lang=js"
export * from "./create.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/private/workspaces/smart-life/smart-life-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1eedcad2')) {
      api.createRecord('1eedcad2', component.options)
    } else {
      api.reload('1eedcad2', component.options)
    }
    module.hot.accept("./create.vue?vue&type=template&id=1eedcad2", function () {
      api.rerender('1eedcad2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/goods/welfare/create.vue"
export default component.exports